import { useTranslation } from 'react-i18next';
import PageHeader from '@casops/components/layout/page-header/PageHeader';
import StandardPage from '@casops/templates/standard-page/StandardPage';
import { useMemo } from 'react';
import NavTabs from '@cas/components/tabs/nav-tabs/NavTabs';
import { Outlet } from 'react-router-dom';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';
import { QueryTag, TagList } from '@casops/store/api';
import { TagDescription } from '@reduxjs/toolkit/query';
import GeofenceVersionTime from '@casops/components/layout/geofence-version-time/GeofenceVersionTime';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  { type: QueryTag.GeofenceStyle, id: TagList }, // Used: table, form.
  { type: QueryTag.GeofenceArea, id: TagList }, // Used: form, map.
  { type: QueryTag.GeofenceSpeedLimit, id: TagList }, // Used: form.
  { type: QueryTag.GeofenceHoldTime, id: TagList }, // Used: form.
  QueryTag.GeofenceVersion, // Used: GeofenceVersionTime
];

export const GeofenceSettingsPage = () => {
  const { t } = useTranslation();

  const tabs = useMemo<NavTabModel[]>(
    () => [
      {
        title: t('Navigation.Styles'),
        to: '/configuration/geofence-settings/styles',
      },
      {
        title: t('Navigation.Areas'),
        to: '/configuration/geofence-settings/areas',
      },
      {
        title: t('Navigation.SpeedLimits'),
        to: '/configuration/geofence-settings/speed-limits',
      },
      {
        title: t('Navigation.HoldTimes'),
        to: '/configuration/geofence-settings/hold-times',
      },
    ],
    [t],
  );

  return (
    <StandardPage
      header={
        <PageHeader
          title={t('Navigation.GeofenceSettings')}
          tagsToClearOnRefresh={tagsToClearOnRefresh}
        >
          <GeofenceVersionTime />
        </PageHeader>
      }
    >
      <NavTabs tabs={tabs} hasBorder />
      <Outlet />
    </StandardPage>
  );
};

export default GeofenceSettingsPage;
